<template>
    <div class="loading">
        <i></i>
        <i></i>
        <i></i>
        <i></i>
    </div>
</template>

<script>
export default {
    name: 'Loader',
    data() {
        return {};
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/loaders.scss" as *;

</style>
